export const LANDING = '/';
export const SIGN_UP = '/signup';
export const SIGN_IN = '/signin';
export const ADMIN = '/admin';
export const CHAT = '/code-talk-chat';
export const AI_CHAT = '/ai-chat';
export const ROOMS = '/rooms';
export const ROOM = '/rooms/:id';